import { AgencyId, UserId } from "@inrev/common";
import { useAdminFetchAgentPreviewsForAgency } from "@portal/api/agency/admin";
import { FC, useMemo } from "react";
import { DropdownInput } from "./DropdownInput";

export type AgentSelectorInputProps = {
	agencyId: AgencyId | "" | null | undefined;
	value: UserId | null;
	onChange: (value: UserId | null) => void;
	testId?: string;
	disabled?: boolean;
	readonly?: boolean;
	compact?: boolean;
	error?: boolean;
	includeInactive?: boolean;
	placeholder?: string;
	optionsClassName?: string;
};

export const AgentSelectorInput: FC<AgentSelectorInputProps> = ({
	agencyId,
	value,
	onChange,
	testId = "agent-selector-dropdown",
	disabled,
	readonly,
	compact,
	error,
	includeInactive,
	placeholder,
	optionsClassName,
}) => {
	const { agentPreviews, agentPreviewsLoading } = useAdminFetchAgentPreviewsForAgency(
		agencyId || undefined,
		includeInactive,
	);

	const agentOptions = useMemo(
		() =>
			(agentPreviews ?? []).map((agent) => ({
				value: agent.id,
				label: agent.displayName,
			})),
		[agentPreviews],
	);

	return (
		<DropdownInput
			testId={testId}
			value={value ?? undefined}
			placeholder={
				!agencyId
					? "Select an agency first"
					: agentPreviewsLoading
						? "Loading agents…"
						: (placeholder ?? "Select agent")
			}
			disabled={disabled || !agencyId}
			readonly={readonly}
			compact={compact}
			error={error}
			options={agentOptions}
			onChange={onChange}
			optionsClassName={optionsClassName}
		/>
	);
};
